import { TComment } from '@valuecase/common'
import { useMemo } from 'react'
import { extractTitleFromQuillObject } from '../../utils/extractTitleFromQuillObject'

export const useCommentTitle = ({ comment }: { comment?: TComment }) => {
  return useMemo(() => {
    if (!comment) return null

    const pageTitle = extractTitleFromQuillObject(comment.page?.versions?.[0]?.asset?.data?.title)

    const nodeTitle = extractTitleFromQuillObject(comment.node?.versions?.[0]?.asset?.data?.title)

    if (pageTitle && nodeTitle) {
      return [pageTitle, nodeTitle]
    }

    return ['General comment']
  }, [comment])
}
